import { LoginInKioskLayout } from '@/layouts';
import { EKioskRouterNames } from '@/types';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Login = lazy(() => import('@/pages/Login/pages/Login'));

const ForgotPasswordEmailExisting = lazy(
  () => import('@/pages/Login/pages/ForgotPasswordEmailExisting'),
);

const Signup = lazy(() => import('@/pages/Login/pages/Signup'));

const ForgotPasswordCreateNew = lazy(
  () => import('@/pages/Login/pages/ForgotPasswordCreateNew'),
);

const PasswordResetConfirmation = lazy(
  () => import('@/pages/Login/pages/PasswordResetConfirmation'),
);

const KioskContinue = lazy(
  () => import('../../pages/Kiosk/pages/KioskContinue'),
);
const KioskLogoutNotice = lazy(
  () => import('../../pages/Kiosk/pages/KioskLogoutNotice'),
);

const KioskUnavailable = lazy(
  () => import('../../pages/Kiosk/pages/KioskUnavailable'),
);

export const kioskPublicRoutes: RouteObject[] = [
  {
    path: EKioskRouterNames.KIOSK__UNAVAILABLE,
    element: <KioskUnavailable />,
  },
  {
    path: EKioskRouterNames.KIOSK__LOGOUT_NOTICE,
    element: <KioskLogoutNotice variant="logout" />,
  },
  {
    path: EKioskRouterNames.KIOSK__UNAVAILABLE_NOTICE,
    element: <KioskLogoutNotice variant="unavailable" />,
  },
  {
    element: <LoginInKioskLayout />,
    children: [
      {
        path: EKioskRouterNames.KIOSK__CONTINUE,
        element: <KioskContinue />,
      },
      {
        path: EKioskRouterNames.KIOSK__LOGIN_USER,
        element: <Login />,
      },
      {
        path: EKioskRouterNames.KIOSK__FORGOT_PASSWORD,
        element: <ForgotPasswordEmailExisting />,
      },
      {
        path: EKioskRouterNames.KIOSK__SIGNUP_USER,
        element: <Signup />,
      },
      {
        path: EKioskRouterNames.KIOSK__RESET_PASSWORD,
        element: <ForgotPasswordCreateNew />,
      },
      {
        path: EKioskRouterNames.KIOSK__PASSWORD_RESET_CONFIRMATION,
        element: <PasswordResetConfirmation />,
      },
    ],
  },
];
